/* eslint-disable @typescript-eslint/unbound-method */
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { EquipmentsExpandedType } from '@/features/equipments/types';

export const equipmentsExpandedAdapter = createEntityAdapter<EquipmentsExpandedType>();

/** Слайс стейта, хранящий раскрытые группы оборудования и опций для автомобиля */
export const equipmentsExpandedSlice = createSlice({
  name: 'equipmentsExpanded',
  initialState: equipmentsExpandedAdapter.getInitialState(),
  reducers: {
    setEquipmentsExpanded: equipmentsExpandedAdapter.setOne,
    resetEquipmentsExpanded: equipmentsExpandedAdapter.removeOne,
    upsertEquipmentsExpanded: equipmentsExpandedAdapter.upsertOne,
  },
});

export default equipmentsExpandedSlice.reducer;
